const zh = {
    'language': '中文',
    '账号': '账号',
    '密码': '密码',
    '验证码': '验证码',
    '登录': '登录',
    '注册': '注册',
    '填写信息': '填写信息',
    '咨询内容': '咨询内容',
    '关闭': '关闭',
    '确认': '确认',
    '选择客服': '选择客服',
    '商户管理': '商户管理',
    '配置管理': '配置管理',
    '退出': '退出',
    '新建商户': '新建商户',
    '名称': '名称',
    '账号': '账号',
    '邮箱': '邮箱',
    '状态': '状态',
    '操作': '操作',
    '正常': '正常',
    '禁止登录': '禁止登录',
    '修改密码': '修改密码',
    '名称': '名称',
    '值': '值',
    '新建商户': '新建商户',
    '姓名': '姓名',
    '密码': '密码',
    '手机号': '手机号',
    '邮箱': '邮箱',
    '关闭': '关闭',
    '确认': '确认',
    '在线': '在线',
    '下线': '下线',
    '状态': '状态',
    '在线': '在线',
    '离开': '离开',
    '我的账户': '我的账户',
    '退出': '退出',
    '个人资料': '个人资料',
    '默认': '默认',
    '收藏': '收藏',
    '隐藏': '隐藏',
    '所有': '所有',
    '置顶': '置顶',
    '收藏': '收藏',
    '隐藏': '隐藏',
    '移除标记': '移除标记',
    '通知信息': '通知信息',
    '用户昵称': '用户昵称',
    '客服昵称': '客服昵称',
    '消息内容': '消息内容',
    '发送时间': '发送时间',
    '修改密码': '修改密码',
    '姓名': '姓名',
    '昵称': '昵称',
    '邮箱': '邮箱',
    '修改密码': '修改密码',
    '原密码': '原密码',
    '新密码': '新密码',
    '我的账户': '我的账户',
    '用户表单编辑': '用户表单编辑',
    '部署代码': '部署代码',
    '知识库': '知识库',
    '暂无聊天记录': '暂无聊天记录',
    '修改信息': '修改信息',
    '返回': '返回',
    '密码长度最小为6位': '密码长度最小为6位',
    '邮箱格式不正确': '邮箱格式不正确',
    '获取验证码': '获取验证码',
    '请输入邮箱': '请输入邮箱',
    '请输入密码': '请输入密码',
    '请确认密码': '请确认密码',
    '请输入验证码': '请输入验证码',
    '请等待60秒后再获取验证码': '请等待60秒后再获取验证码',
    '请先输入邮箱': '请先输入邮箱',
    '剩余': '剩余',
    '秒': '秒',
    '创建表单项': '创建表单项',
    '常用表单项已经全部添加': '常用表单项已经全部添加',
    '类型': '类型',
    '填写': '填写',
    '选填': '选填',
    '键': '键',
    '选填内容': '选填内容',
    '格式为': '格式为',
    '排序': '排序',
    '描述': '描述',
    '修改表单项目': '修改表单项目',
    '表单不完整': '表单不完整',
    '此操作将永久删除该配置项, 是否继续?此操作将永久删除该配置项, 是否继续?': '122222',
    '提示': '提示',
    '添加客服': '添加客服',
    '登录账号': '登录账号',
    '客服名称': '客服名称',
    '备注': '备注',
    '头像': '头像',
    '接线': '接线',
    '修改密码': '修改密码',
    '设置头像': '设置头像',
    '添加客服': '添加客服',
    '账户(必须为3-10位字母数字组合*)': '账户(必须为3-10位字母数字组合*)',
    '备注': '备注',
    '修改密码': '修改密码',
    '否': '否',
    '设置头像': '设置头像',
}
export default zh;
